import { useEffect, useState } from "react";
import { Button, Table, TableColumnsType, TableProps, message } from "antd";
import TenantFeatureApi from "../../../../../../api/TenantFeatureApi";
import { TableWrapper, TenantFeaturesWrapper, ToolBarWrapper } from "./TenantFeatures.styled";
import { ToolBarLeftWrapper, ToolBarRightWrapper } from "../../../../../user-management/UserManagement.styled";

interface TenantFeatureMeta {
    id: number;
    name: string;
    description: string;
    code: string;
    codePath: string;
    children: TenantFeatureMeta[];
}

interface TenantFeaturesProps {
    tenantView: any
}

const TenantFeatures: React.FC<TenantFeaturesProps> = (props)=> {

    let tenantFeatureApi = new TenantFeatureApi();
    const [messageApi, contextHolder] = message.useMessage();

    // state
    let [tenantFeatureMetas, setTenantFeatureMetas] = useState<any[]>([]);
    let [tenantFeatureCodePaths, setTenantFeatureCodePaths] = useState<any[]>([]);
    let [loading, setLoading] = useState<boolean>(false);

    // methods
    let onSave = async ()=> {
        await tenantFeatureApi.setTenantFeatures(props.tenantView.tenant.id, tenantFeatureCodePaths);
        messageApi.open({
            type: 'success',
            content: '保存成功',
        });
    };

    // effect
    useEffect(()=> {
        let load = async ()=> {
            setLoading(true);
            let tenantFeatureMetas = (await tenantFeatureApi.getMetas()).data.data;
            setTenantFeatureMetas(tenantFeatureMetas);
            let tenantFeatures = (await tenantFeatureApi.getTenantFeatures(props.tenantView.tenant.id)).data.data;
            setTenantFeatureCodePaths(tenantFeatures.map(e=> e.featureCodePath));
            setLoading(false);
        }
        load();
    }, []);

    const rowSelection: TableProps<TenantFeatureMeta>['rowSelection'] = {
        type: 'checkbox',
        selectedRowKeys: tenantFeatureCodePaths,
        onSelect: (record, selected, selectedRows) => {
            let visitTenantFeatureMeta = (tenantFeatureMeta: TenantFeatureMeta, onVisit: (TenantFeatureMeta: TenantFeatureMeta)=> void)=> {
                onVisit(tenantFeatureMeta);
                if (tenantFeatureMeta.children) {
                    for (let child of tenantFeatureMeta.children) {
                        visitTenantFeatureMeta(child, onVisit);
                    }
                }
                return;
            };

            let visitTenantFeatureMetas = (onVisit: (TenantFeatureMeta: TenantFeatureMeta)=> void)=> {
                for(let tenantFeatureMeta of tenantFeatureMetas) {
                    visitTenantFeatureMeta(tenantFeatureMeta, onVisit);
                }
            }

            let newTenantFeatureCodePaths = [].concat(tenantFeatureCodePaths);
            if (selected) {
                visitTenantFeatureMetas((tenantFeatureMeta)=> {
                    if (tenantFeatureMeta.codePath.indexOf(record.codePath) == 0 && newTenantFeatureCodePaths.indexOf(tenantFeatureMeta.codePath) < 0) {
                        newTenantFeatureCodePaths.push(tenantFeatureMeta.codePath);
                    }

                    if (record.codePath.indexOf(tenantFeatureMeta.codePath) == 0 && newTenantFeatureCodePaths.indexOf(tenantFeatureMeta.codePath) < 0) {
                        newTenantFeatureCodePaths.push(tenantFeatureMeta.codePath);
                    }
                });
            } else {
                visitTenantFeatureMetas((tenantFeatureMeta)=> {
                    if (tenantFeatureMeta.codePath.indexOf(record.codePath) == 0 && newTenantFeatureCodePaths.indexOf(tenantFeatureMeta.codePath) >= 0) {
                        let index = newTenantFeatureCodePaths.indexOf(tenantFeatureMeta.codePath);
                        newTenantFeatureCodePaths.splice(index, 1);
                    }
                });
            }
            setTenantFeatureCodePaths(newTenantFeatureCodePaths);
        },
        getCheckboxProps: (record: TenantFeatureMeta) => ({
            name: record.codePath,
        }),
    };

    const columns: TableColumnsType<any> = [
        {
            title: '名称',
            dataIndex: 'name',
            key: 'name',
            width: '300px',
            align: 'left',
            render: (text, record, index)=> {
                return <b>{record.name}</b>
            }
        },
        {
            title: '描述',
            dataIndex: 'description',
            key: 'description',
            align: 'left',
            render: (text, record, index)=> {
                return <span>{record.description}</span>
            }
        },
    ];

    // render
    return <TenantFeaturesWrapper>
        {contextHolder}
        <ToolBarWrapper>
            <ToolBarLeftWrapper>
                <Button type="primary" onClick={onSave}>保存</Button>
            </ToolBarLeftWrapper>
            <ToolBarRightWrapper>
            </ToolBarRightWrapper>
        </ToolBarWrapper>
        <TableWrapper>
            <Table
                rowKey={(record)=> record.codePath}
                columns={columns} 
                rowSelection={rowSelection}
                dataSource={tenantFeatureMetas}
                loading={loading}
                pagination={false}
            />
        </TableWrapper>
    </TenantFeaturesWrapper>
}

export default TenantFeatures;
